import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";

import "../styles/Lecture.css";
import { useParams } from "react-router";
import Topnav from "../components/Topnav";
import Spinner from "../components/Spinner";
import { MdPersonAdd, MdSend } from "react-icons/md";
import { isEmpty } from "../functions/isEmpty";

export default function Lecture({ apiURL, userID, setUserID }) {
  const endOfMessagesRef = useRef(null);
  const { id } = useParams();
  const [textinput, setTextinput] = useState("");
  const [model, setModel] = useState("gpt-4o-mini");
  const [personality, setPersonality] = useState("Du bist Marc Aurel.");
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const [phase, setPhase] = useState(0);
  const [phase1, setPhase1] = useState("");
  const [phase2, setPhase2] = useState("");
  const [phase3, setPhase3] = useState("");
  const [phase4, setPhase4] = useState("");
  const [phase5, setPhase5] = useState("");

  const [phase6, setPhase6] = useState("");
  const [phase7, setPhase7] = useState("");
  const [phase8, setPhase8] = useState("");
  const [phase9, setPhase9] = useState("");
  const [phase10, setPhase10] = useState("");

  const [phase11, setPhase11] = useState("");
  const [phase12, setPhase12] = useState("");
  const [phase13, setPhase13] = useState("");
  const [phase14, setPhase14] = useState("");
  const [phase15, setPhase15] = useState("");

  const [phase16, setPhase16] = useState("");
  const [phase17, setPhase17] = useState("");
  const [phase18, setPhase18] = useState("");
  const [phase19, setPhase19] = useState("");
  const [phase20, setPhase20] = useState("");

  const [reason, setReason] = useState("");

  const sendMessage = async () => {
    setIsLoading(true);
    if (textinput.length < 1) {
      alert(
        "Deine Nachricht ist leer. Tippe eine Nachricht ein, bevor du absendest."
      );
      setIsLoading(false);
      return;
    }
    const userMessage = { from_user: 1, content: textinput };
    setMessages((prev) => [...prev, userMessage]); // ⬅️ korrektes Updaten

    setTextinput(""); // Eingabefeld leeren

    try {
      const formData = new FormData();
      formData.append("users_id", userID);
      formData.append("from_user", 1);
      formData.append("content", textinput);
      formData.append("personality", personality);
      formData.append("model", model);
      formData.append("phase", phase);
      formData.append("next_phase_1", phase1);
      formData.append("next_phase_2", phase2);
      formData.append("next_phase_3", phase3);
      formData.append("next_phase_4", phase4);
      formData.append("next_phase_5", phase5);

      formData.append("next_phase_6", phase6);
      formData.append("next_phase_7", phase7);
      formData.append("next_phase_8", phase8);
      formData.append("next_phase_9", phase9);
      formData.append("next_phase_10", phase10);

      formData.append("next_phase_11", phase11);
      formData.append("next_phase_12", phase12);
      formData.append("next_phase_13", phase13);
      formData.append("next_phase_14", phase14);
      formData.append("next_phase_15", phase15);

      formData.append("next_phase_16", phase16);
      formData.append("next_phase_17", phase17);
      formData.append("next_phase_18", phase18);
      formData.append("next_phase_19", phase19);
      formData.append("next_phase_20", phase20);

      const response = await fetch(
        "https://cloud.meternityai.com/messages/create_new_message.php",
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error(`Fehler beim Senden: ${response.statusText}`);
      }

      const result = await response.json();

      const botMessage = { from_user: 0, content: result.openai_response };
      setReason(result.system_control.reason);
      if (result.system_control.phase_reached) {
        setPhase((prev) => prev + 1);
      }
      setMessages((prev) => [...prev, botMessage]); // ⬅️ korrektes Updaten
      console.log(result.openai_response);
      setIsLoading(false);

      return result;
    } catch (error) {
      console.error("Fehler beim Senden der Nachricht:", error);
      setIsLoading(false);

      return null;
    }
  };

  useEffect(() => {
    if (endOfMessagesRef.current) {
      endOfMessagesRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  useEffect(() => {
    const handleEnterPress = (event) => {
      // ✅ NUR auslösen, wenn die fokussierte Elementklasse passt
      const activeEl = document.activeElement;
      const isTargetTextarea =
        activeEl && activeEl.classList.contains("lecture_body_inputbox_input");

      if (event.key === "Enter" && isTargetTextarea) {
        event.preventDefault();
        sendMessage();
      }
    };

    window.addEventListener("keydown", handleEnterPress);

    return () => {
      window.removeEventListener("keydown", handleEnterPress);
    };
  }, [textinput, messages, userID, model, phase]);

  useEffect(async () => {
    const resa = await fetch(
      `${apiURL}/messages/index.php?users_id=` + userID,
      {
        method: "GET",
        headers: {
          //   Authorization: `Bearer ${authToken?.JWT}`,
          "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        //    body: JSON.stringify({            }),
      }
    );
    await resa.text().then((value) => setMessages(JSON.parse(value)));
  }, [id, userID]);

  const anydata = [];

  useEffect(() => {
    if (initialized) {
      localStorage.setItem("@stoicpersonality", personality);
      localStorage.setItem("@stoicphase", phase.toString());
      localStorage.setItem("@stoicphase1", phase1);
      localStorage.setItem("@stoicphase2", phase2);
      localStorage.setItem("@stoicphase3", phase3);
      localStorage.setItem("@stoicphase4", phase4);
      localStorage.setItem("@stoicphase5", phase5);

      localStorage.setItem("@stoicphase6", phase6);
      localStorage.setItem("@stoicphase7", phase7);
      localStorage.setItem("@stoicphase8", phase8);
      localStorage.setItem("@stoicphase9", phase9);
      localStorage.setItem("@stoicphase10", phase10);

      localStorage.setItem("@stoicphase11", phase11);
      localStorage.setItem("@stoicphase12", phase12);
      localStorage.setItem("@stoicphase13", phase13);
      localStorage.setItem("@stoicphase14", phase14);
      localStorage.setItem("@stoicphase15", phase15);

      localStorage.setItem("@stoicphase16", phase16);
      localStorage.setItem("@stoicphase17", phase17);
      localStorage.setItem("@stoicphase18", phase18);
      localStorage.setItem("@stoicphase19", phase19);
      localStorage.setItem("@stoicphase20", phase20);
    } else {
      const personally = localStorage.getItem("@stoicpersonality");
      if (isEmpty(personally)) {
        setPersonality("Du bist Marc Aurel.");
      } else {
        setPersonality(personally);
      }

      const local_phase = localStorage.getItem("@stoicphase");
      if (isEmpty(local_phase)) {
        setPhase(0);
      } else {
        setPhase(parseInt(local_phase));
      }

      const local_phase1 = localStorage.getItem("@stoicphase1");
      if (isEmpty(local_phase1)) {
        setPhase1("");
      } else {
        setPhase1(local_phase1);
      }

      const local_phase2 = localStorage.getItem("@stoicphase2");
      if (isEmpty(local_phase2)) {
        setPhase2("");
      } else {
        setPhase2(local_phase2);
      }
      const local_phase3 = localStorage.getItem("@stoicphase3");
      if (isEmpty(local_phase3)) {
        setPhase3("");
      } else {
        setPhase3(local_phase3);
      }
      const local_phase_4 = localStorage.getItem("@stoicphase4");
      if (isEmpty(local_phase_4)) {
        setPhase4("");
      } else {
        setPhase4(local_phase_4);
      }

      const local_phase5 = localStorage.getItem("@stoicphase5");
      if (isEmpty(local_phase5)) {
        setPhase5("");
      } else {
        setPhase5(local_phase5);
      }

      const local_phase6 = localStorage.getItem("@stoicphase6");
      if (isEmpty(local_phase6)) {
        setPhase6("");
      } else {
        setPhase6(local_phase6);
      }
      const local_phase7 = localStorage.getItem("@stoicphase7");
      if (isEmpty(local_phase7)) {
        setPhase7("");
      } else {
        setPhase7(local_phase7);
      }
      const local_phase8 = localStorage.getItem("@stoicphase8");
      if (isEmpty(local_phase8)) {
        setPhase8("");
      } else {
        setPhase8(local_phase8);
      }
      const local_phase9 = localStorage.getItem("@stoicphase9");
      if (isEmpty(local_phase9)) {
        setPhase9("");
      } else {
        setPhase9(local_phase9);
      }
      const local_phase10 = localStorage.getItem("@stoicphase10");
      if (isEmpty(local_phase10)) {
        setPhase10("");
      } else {
        setPhase10(local_phase10);
      }
      const local_phase11 = localStorage.getItem("@stoicphase11");
      if (isEmpty(local_phase11)) {
        setPhase11("");
      } else {
        setPhase11(local_phase11);
      }
      const local_phase12 = localStorage.getItem("@stoicphase12");
      if (isEmpty(local_phase12)) {
        setPhase12("");
      } else {
        setPhase12(local_phase12);
      }
      const local_phase13 = localStorage.getItem("@stoicphase13");
      if (isEmpty(local_phase13)) {
        setPhase13("");
      } else {
        setPhase13(local_phase13);
      }
      const local_phase14 = localStorage.getItem("@stoicphase14");
      if (isEmpty(local_phase14)) {
        setPhase14("");
      } else {
        setPhase14(local_phase14);
      }
      const local_phase15 = localStorage.getItem("@stoicphase15");
      if (isEmpty(local_phase15)) {
        setPhase15("");
      } else {
        setPhase15(local_phase15);
      }
      const local_phase16 = localStorage.getItem("@stoicphase16");
      if (isEmpty(local_phase16)) {
        setPhase16("");
      } else {
        setPhase16(local_phase16);
      }
      const local_phase17 = localStorage.getItem("@stoicphase17");
      if (isEmpty(local_phase17)) {
        setPhase17("");
      } else {
        setPhase17(local_phase17);
      }
      const local_phase18 = localStorage.getItem("@stoicphase18");
      if (isEmpty(local_phase18)) {
        setPhase18("");
      } else {
        setPhase18(local_phase18);
      }
      const local_phase19 = localStorage.getItem("@stoicphase19");
      if (isEmpty(local_phase19)) {
        setPhase19("");
      } else {
        setPhase19(local_phase19);
      }
      const local_phase20 = localStorage.getItem("@stoicphase20");
      if (isEmpty(local_phase20)) {
        setPhase20("");
      } else {
        setPhase20(local_phase20);
      }

      setInitialized(true);
    }
  }, [
    personality,
    initialized,
    phase1,
    phase2,
    phase3,
    phase4,
    phase5,
    phase6,
    phase7,
    phase8,
    phase9,
    phase10,
    phase11,
    phase12,
    phase13,
    phase14,
    phase15,
    phase16,
    phase17,
    phase18,
    phase19,
    phase20,
    phase,
  ]);

  const resetChat = () => {
    localStorage.removeItem("@stoicmeternity");

    setUserID(null);
    setPhase(0);
  };

  return (
    <div className="lecture">
      <Topnav phase={phase} resetChat={resetChat} reason={reason} />

      <div className="lecture_body">
        <div className="lecture_body_chat">
          {messages?.map((message, index) =>
            message.from_user == 1 ? (
              <div className="lecture_body_chat_userrow" key={message.id}>
                <div className="lecture_body_chat_userrow_message">
                  {message.content}
                </div>
              </div>
            ) : (
              <div className="lecture_body_chat_tutorrow" key={message.id}>
                <div className="lecture_body_chat_tutorrow_message">
                  {message.content}
                </div>
              </div>
            )
          )}
          {isLoading && (
            <div className="lecture_body_chat_tutorrow">
              <div className="lecture_body_chat_tutorrow_message">
                <Spinner />
              </div>
            </div>
          )}
          <div ref={endOfMessagesRef} /> {/* 🟢 Scroll-Ziel */}
        </div>
        <div className="lecture_body_inputbox">
          <textarea
            className="lecture_body_inputbox_input"
            placeholder="Schreibe mit deinem stoischen Freund"
            value={textinput}
            onChange={(e) => setTextinput(e.target.value)}
          />
          <div
            className="lecture_body_inputbox_input_send"
            onClick={() => sendMessage()}>
            <SendIcon />
          </div>
        </div>
      </div>
      <div className="lecture_sidebar">
        <div className="lecture_sidebar_title">KI Modell wählen</div>
        <div className="lecture_sidebar_model">
          <select
            className="lecture_sidebar_model_select"
            onChange={(e) => setModel(e.target.value)}>
            <option
              className="lecture_sidebar_model_select_option"
              value="gpt-4o-mini">
              GPT 4o
            </option>
            <option
              className="lecture_sidebar_model_select_option"
              value="o3-mini">
              GPT o3
            </option>
          </select>
        </div>
        <div className="lecture_sidebar_title">Persönlichkeit</div>
        <div className="lecture_sidebar_personality">
          <textarea
            className="lecture_sidebar_personality_input"
            placeholder={"Verhalten Phase 1"}
            value={personality}
            onChange={(e) => setPersonality(e.target.value)}
          />
        </div>
        <div className="lecture_sidebar_title">Phase 1</div>

        <div className="lecture_sidebar_phase">
          <textarea
            value={phase1}
            onChange={(e) => setPhase1(e.target.value)}
            className="lecture_sidebar_phase_input"
            placeholder="Beschreibe was geantwortet werden soll und woran erkannt wird, dass die Phase abgeschlossen wurde"
          />
        </div>
        <div className="lecture_sidebar_title">Phase 2</div>

        <div className="lecture_sidebar_phase">
          <textarea
            value={phase2}
            onChange={(e) => setPhase2(e.target.value)}
            className="lecture_sidebar_phase_input"
            placeholder="Beschreibe was geantwortet werden soll und woran erkannt wird, dass die Phase abgeschlossen wurde"
          />
        </div>
        <div className="lecture_sidebar_title">Phase 3</div>

        <div className="lecture_sidebar_phase">
          <textarea
            value={phase3}
            onChange={(e) => setPhase3(e.target.value)}
            className="lecture_sidebar_phase_input"
            placeholder="Beschreibe was geantwortet werden soll und woran erkannt wird, dass die Phase abgeschlossen wurde"
          />
        </div>
        <div className="lecture_sidebar_title">Phase 4</div>

        <div className="lecture_sidebar_phase">
          <textarea
            value={phase4}
            onChange={(e) => setPhase4(e.target.value)}
            className="lecture_sidebar_phase_input"
            placeholder="Beschreibe was geantwortet werden soll und woran erkannt wird, dass die Phase abgeschlossen wurde"
          />
        </div>
        <div className="lecture_sidebar_title">Phase 5</div>

        <div className="lecture_sidebar_phase">
          <textarea
            value={phase5}
            onChange={(e) => setPhase5(e.target.value)}
            className="lecture_sidebar_phase_input"
            placeholder="Beschreibe was geantwortet werden soll und woran erkannt wird, dass die Phase abgeschlossen wurde"
          />
        </div>

        <div className="lecture_sidebar_title">Phase 6</div>

        <div className="lecture_sidebar_phase">
          <textarea
            value={phase6}
            onChange={(e) => setPhase6(e.target.value)}
            className="lecture_sidebar_phase_input"
            placeholder="Beschreibe was geantwortet werden soll und woran erkannt wird, dass die Phase abgeschlossen wurde"
          />
        </div>
        <div className="lecture_sidebar_title">Phase 7</div>

        <div className="lecture_sidebar_phase">
          <textarea
            value={phase7}
            onChange={(e) => setPhase7(e.target.value)}
            className="lecture_sidebar_phase_input"
            placeholder="Beschreibe was geantwortet werden soll und woran erkannt wird, dass die Phase abgeschlossen wurde"
          />
        </div>
        <div className="lecture_sidebar_title">Phase 8</div>

        <div className="lecture_sidebar_phase">
          <textarea
            value={phase8}
            onChange={(e) => setPhase8(e.target.value)}
            className="lecture_sidebar_phase_input"
            placeholder="Beschreibe was geantwortet werden soll und woran erkannt wird, dass die Phase abgeschlossen wurde"
          />
        </div>
        <div className="lecture_sidebar_title">Phase 9</div>

        <div className="lecture_sidebar_phase">
          <textarea
            value={phase9}
            onChange={(e) => setPhase9(e.target.value)}
            className="lecture_sidebar_phase_input"
            placeholder="Beschreibe was geantwortet werden soll und woran erkannt wird, dass die Phase abgeschlossen wurde"
          />
        </div>
        <div className="lecture_sidebar_title">Phase 10</div>

        <div className="lecture_sidebar_phase">
          <textarea
            value={phase10}
            onChange={(e) => setPhase10(e.target.value)}
            className="lecture_sidebar_phase_input"
            placeholder="Beschreibe was geantwortet werden soll und woran erkannt wird, dass die Phase abgeschlossen wurde"
          />
        </div>

        <div className="lecture_sidebar_title">Phase 11</div>

        <div className="lecture_sidebar_phase">
          <textarea
            value={phase11}
            onChange={(e) => setPhase11(e.target.value)}
            className="lecture_sidebar_phase_input"
            placeholder="Beschreibe was geantwortet werden soll und woran erkannt wird, dass die Phase abgeschlossen wurde"
          />
        </div>
        <div className="lecture_sidebar_title">Phase 12</div>

        <div className="lecture_sidebar_phase">
          <textarea
            value={phase12}
            onChange={(e) => setPhase12(e.target.value)}
            className="lecture_sidebar_phase_input"
            placeholder="Beschreibe was geantwortet werden soll und woran erkannt wird, dass die Phase abgeschlossen wurde"
          />
        </div>
        <div className="lecture_sidebar_title">Phase 13</div>

        <div className="lecture_sidebar_phase">
          <textarea
            value={phase13}
            onChange={(e) => setPhase13(e.target.value)}
            className="lecture_sidebar_phase_input"
            placeholder="Beschreibe was geantwortet werden soll und woran erkannt wird, dass die Phase abgeschlossen wurde"
          />
        </div>
        <div className="lecture_sidebar_title">Phase 14</div>

        <div className="lecture_sidebar_phase">
          <textarea
            value={phase14}
            onChange={(e) => setPhase14(e.target.value)}
            className="lecture_sidebar_phase_input"
            placeholder="Beschreibe was geantwortet werden soll und woran erkannt wird, dass die Phase abgeschlossen wurde"
          />
        </div>
        <div className="lecture_sidebar_title">Phase 15</div>

        <div className="lecture_sidebar_phase">
          <textarea
            value={phase15}
            onChange={(e) => setPhase15(e.target.value)}
            className="lecture_sidebar_phase_input"
            placeholder="Beschreibe was geantwortet werden soll und woran erkannt wird, dass die Phase abgeschlossen wurde"
          />
        </div>
        <div className="lecture_sidebar_title">Phase 16</div>

        <div className="lecture_sidebar_phase">
          <textarea
            value={phase16}
            onChange={(e) => setPhase16(e.target.value)}
            className="lecture_sidebar_phase_input"
            placeholder="Beschreibe was geantwortet werden soll und woran erkannt wird, dass die Phase abgeschlossen wurde"
          />
        </div>
        <div className="lecture_sidebar_title">Phase 17</div>

        <div className="lecture_sidebar_phase">
          <textarea
            value={phase17}
            onChange={(e) => setPhase17(e.target.value)}
            className="lecture_sidebar_phase_input"
            placeholder="Beschreibe was geantwortet werden soll und woran erkannt wird, dass die Phase abgeschlossen wurde"
          />
        </div>
        <div className="lecture_sidebar_title">Phase 18</div>

        <div className="lecture_sidebar_phase">
          <textarea
            value={phase18}
            onChange={(e) => setPhase18(e.target.value)}
            className="lecture_sidebar_phase_input"
            placeholder="Beschreibe was geantwortet werden soll und woran erkannt wird, dass die Phase abgeschlossen wurde"
          />
        </div>
        <div className="lecture_sidebar_title">Phase 19</div>

        <div className="lecture_sidebar_phase">
          <textarea
            value={phase19}
            onChange={(e) => setPhase19(e.target.value)}
            className="lecture_sidebar_phase_input"
            placeholder="Beschreibe was geantwortet werden soll und woran erkannt wird, dass die Phase abgeschlossen wurde"
          />
        </div>
        <div className="lecture_sidebar_title">Phase 20</div>

        <div className="lecture_sidebar_phase">
          <textarea
            value={phase20}
            onChange={(e) => setPhase20(e.target.value)}
            className="lecture_sidebar_phase_input"
            placeholder="Beschreibe was geantwortet werden soll und woran erkannt wird, dass die Phase abgeschlossen wurde"
          />
        </div>
      </div>
    </div>
  );
}

const SendIcon = styled(MdSend)`
  font-size: 20px;
  color: #ffffff;
`;
